// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * BiDirectionalNode — Custom node to support seamless bidirectional offset edges.
 *
 * Implements two source handles (left and right) and two target handles (left and right),
 * allowing bidirectional edges to naturally route without looping backwards around the node.
 */
import React, { memo, useMemo } from 'react';
import { Position } from 'reactflow';
import { useTheme } from '@mui/material/styles';
import SolyticsBox from '../../../SolyticsBox';
import NodeHandles from '../shared/NodeHandles';
import NodeTooltip from '../shared/NodeTooltip';
import NodeMenu from '../shared/NodeMenu';
import { CardShape } from './CardNode';
import { NODE_COLOR_SCHEMES } from '../constants';
import { resolveNodeColors } from '../shared/themeColorUtils';

const BiDirectionalNode = memo(({ id, data, parentId }) => {
  const theme = useTheme();

  const colors = useMemo(() => {
    return resolveNodeColors(theme, data, NODE_COLOR_SCHEMES);
  }, [data, theme]);

  const defaultHandles = useMemo(
    () => [
      { type: 'source', position: Position.Right, id: 'right-source' },
      { type: 'target', position: Position.Left, id: 'left-target' },
      { type: 'source', position: Position.Left, id: 'left-source' },
      { type: 'target', position: Position.Right, id: 'right-target' },
    ],
    []
  );

  return (
    <NodeMenu menuItems={data?.menuItems} nodeId={id} parentId={parentId}>
      <NodeTooltip tooltip={data?.tooltip}>
        <SolyticsBox display="inline-flex">
          <CardShape label={data?.label} colors={colors} />
        </SolyticsBox>
      </NodeTooltip>

      <NodeHandles handles={data?.handles} fallbackHandles={defaultHandles} />
    </NodeMenu>
  );
});

BiDirectionalNode.displayName = 'BiDirectionalNode';

export default BiDirectionalNode;
